import {
  DataAction,
  GetAppDataSuccess,
  PostOrdersMultisimSuccess,
  PostOrdersMultisimError,
  PatchOrdersMultisimOrderIdSuccess,
  PatchOrdersMultisimOrderIdError,
} from './dataActions'
import * as dataConstants from './dataConstants'
import { OrdersData, UsersData, ProductsData, EsimData } from './dataApi'

/* ------------- State ------------- */
type DataStateType = typeof initialState
export interface DataState extends DataStateType {}

export const initialState = {
  ordersData: undefined as OrdersData | undefined,
  usersData: undefined as UsersData | undefined,
  productsData: undefined as ProductsData | undefined,
  esimData: undefined as EsimData | undefined,
  isDataFetchPending: false,
  dataFetchError: undefined as string | undefined,
  isPostOrderRequest: false,
  postOrderError: undefined as string | undefined,
  isPatchOrderRequest: false,
  patchOrderError: undefined as string | undefined,
}

/* ------------- Reducers ------------- */
const getAppDataSuccess = (state: DataState, action: GetAppDataSuccess): DataState => {
  const { esimData, ordersData, productsData, usersData } = action

  return {
    ...state,
    esimData,
    ordersData: {
      ...state.ordersData,
      orders: ordersData,
    },
    productsData,
    usersData,
    isDataFetchPending: false,
    dataFetchError: undefined,
  }
}

const postOrdersMultisimSuccess = (state: DataState, action: PostOrdersMultisimSuccess): DataState => {
  return {
    ...state,
    isPostOrderRequest: false,
    postOrderError: undefined,
    ordersData: { ...state.ordersData, postOrderData: action.data },
  }
}

const postOrdersMultisimError = (state: DataState, action: PostOrdersMultisimError): DataState => {
  return {
    ...state,
    isPostOrderRequest: false,
    postOrderError: action.error,
  }
}

const patchOrdersMultisimOrderIdSuccess = (state: DataState, action: PatchOrdersMultisimOrderIdSuccess): DataState => {
  return {
    ...state,
    isPatchOrderRequest: false,
    patchOrderError: undefined,
    ordersData: { ...state.ordersData, patchOrderData: action.data },
  }
}

const patchOrdersMultisimOrderIdError = (state: DataState, action: PatchOrdersMultisimOrderIdError): DataState => {
  return {
    ...state,
    isPatchOrderRequest: false,
    patchOrderError: action.error,
  }
}

export default (state: DataState = initialState, action: DataAction): DataState => {
  switch (action.type) {
    case dataConstants.GET_APP_DATA_REQUEST:
      return { ...state, isDataFetchPending: true, dataFetchError: undefined }
    case dataConstants.GET_APP_DATA_SUCCESS:
      return getAppDataSuccess(state, action)
    case dataConstants.GET_APP_DATA_ERROR:
      return { ...state, isDataFetchPending: false, dataFetchError: action.error }
    case dataConstants.POST_ORDERS_MULTISIM:
      return { ...state, isPostOrderRequest: true, postOrderError: undefined }
    case dataConstants.POST_ORDERS_MULTISIM_SUCCESS:
      return postOrdersMultisimSuccess(state, action)
    case dataConstants.POST_ORDERS_MULTISIM_ERROR:
      return postOrdersMultisimError(state, action)
    case dataConstants.PATCH_ORDERS_MULTISIM_ORDER_ID:
      return { ...state, isPatchOrderRequest: true, patchOrderError: undefined }
    case dataConstants.PATCH_ORDERS_MULTISIM_ORDER_ID_SUCCESS:
      return patchOrdersMultisimOrderIdSuccess(state, action)
    case dataConstants.PATCH_ORDERS_MULTISIM_ORDER_ID_ERROR:
      return patchOrdersMultisimOrderIdError(state, action)
    default:
      return state
  }
}
